import moment from "moment";

/**
 * Indica se o plano da empresa do usuário está ativo (mesma regra do login em useAuth).
 * Empresa id 1 é tratada como sem vencimento.
 */
export const isCompanyPlanActive = (user) => {
  if (!user?.company) return false;
  const companyId = user.company.id ?? user.companyId;
  let dueDate = user.company.dueDate;
  if (companyId === 1) {
    dueDate = "2999-12-31T00:00:00.000Z";
  }
  if (!dueDate) return false;
  return moment().isBefore(moment(dueDate));
};
